import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'service.home',
    defaultMessage: 'Home',
  },
  transactionsTitle: {
    id: 'transactions.title',
    defaultMessage: 'Transaction Log',
  },
});
